if (!Object.assign) {
  Object.defineProperty(Object, "assign", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function (target) {
      "use strict";
      if (target === undefined || target === null) {
        throw new TypeError("Cannot convert first argument to object");
      }
      var to = Object(target);
      for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) {
          continue;
        }
        nextSource = Object(nextSource);
        var keysArray = Object.keys(Object(nextSource));
        for (
          var nextIndex = 0, len = keysArray.length;
          nextIndex < len;
          nextIndex++
        ) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
      return to;
    },
  });
}

//import cookieNotice           from './cookie-notice.js' // Cookie window
import toggleMenu from "./toggle-menu.js"; // Responsive menu
import toggleLang from "./toggle-lang.js";
import countupNumbers from "./numbers.js";
import accordion from "./accordion.js"; //Accordion/Question
import prepareForAnimation from "./animate.js";
import selectAirports from "./select-airports.js";
import customHeadroom from "./give-headroom.js";
import slots from "./slots.js";
import swish from "./swish.js";
import moveClouds from "./move-clouds.js";
import webFont from "webfontloader"; // Web font loader
import smoothScroll from "./smooth-scroll.js";
import svg4everybody from "svg4everybody"; // SVG polyfill
import html2pdf from "html2pdf.js";
import LazyLoad from "vanilla-lazyload";
import swishBtn from "./swish-btn.js";

const home = $(".home .hero");

const pdfElement = document.querySelector(".printable");
if (pdfElement) {
  function makePDF() {
    var opt = {
      margin: 1,
      filename: "klimatreducering-kvitto.pdf",
      image: { type: "pdf", quality: 1 },
      html2canvas: {
        dpi: 192,
        scale: 1.5,
        letterRendering: true,
        useCORS: true,
      },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(opt).from(pdfElement).save();
  }

  setTimeout(makePDF, 3000);
}

if (home.length) {
  moveClouds(home);
}

var lazyLoadInstance = new LazyLoad({
  elements_selector: ".lazy",
});

// Init cookie notice
//cookieNotice()

// Init responsive menu
toggleMenu();

// Init lang-selector
toggleLang();

countupNumbers();

//Init headroom för sticky header
customHeadroom();

//Smooth scroll on anchor
smoothScroll();

// Add classes if animate
prepareForAnimation();

//Calculate how expensive it is to climatecompensate yur journey
if (document.querySelector(".donation-calculate")) {
  selectAirports();
}

//Donate per 20 minute slots
if (document.querySelector(".module-slot")) {
  slots();
}

//Buy by adding amount
if (document.querySelector(".module-swish")) {
  swish();
}

//Init if question-list is present
if (document.querySelector("#question-list")) {
  accordion();
}

$(".add_to_cart_button").on("click", function () {
  $(this).addClass("loading");
});

// SVG polyfill
svg4everybody();

swishBtn();
